import { Component, Inject, OnInit, ViewChildren } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'sd-verify-phone',
  templateUrl: './verify-phone.component.html',
  styleUrls: ['./verify-phone.component.scss']
})
export class VerifyPhoneComponent implements OnInit {

  type: string = 'mobile';
  form: UntypedFormGroup;
  formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
  @ViewChildren('formRow') rows: any;



  // //////////////////////////////////////////////////////
  loading: Boolean = true;
  error: Boolean = false;
  errorMsg: String = '';
  success: Boolean = false;
  otpError: Boolean = false;
  otpErrorMsg: String = '';
  otpUpdated = false;
  otpUpdating = false;
  otpSent: Boolean = false;
  verifyOTPError = false;
  verifyOTPErrorMsg: String = '';
  verifyOTPUpdated = false;
  verifyOTPUpdating = false;

  disableResendBtn = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private verifyMobileDialogRef: MatDialogRef<VerifyPhoneComponent>,
    private api: ApiService, private router: Router,
    public user: UserService,
    public global: GlobalService,
    private toastrService: ToastrService
  ) {
    this.form = this.toFormGroup(this.formInput);
  }


  toFormGroup(elements) {
    const group: any = {};

    elements.forEach(key => {
      group[key] = new UntypedFormControl('', Validators.required);
    });
    return new UntypedFormGroup(group);
  }

  keyUpEvent(event, index) {
    let pos = index;
    if (event.keyCode === 8 && event.which === 8) {
      pos = index - 1;
    } else {
      pos = index + 1;
    }
    if (pos > -1 && pos < this.formInput.length) {
      this.rows._results[pos].nativeElement.focus();
    }

  }

  get otp() { return this.form.get('otp'); }

  ngOnInit() {
    if (this.data.autoSend != false) {
      this.disableResend();
    }
  }

  closeDialog(res = false) {
    this.verifyMobileDialogRef.close({
      'mobile': this.data.mobile,
      'res': res
    });
  }


  onOTPFormSubmit() {

    if (this.form.valid) {
      this.verifyOTPUpdating = true;
      const values = Object.values(this.form.value);
      let inputOTPValue = values.join("")
      console.log(inputOTPValue)


      this.api.verifyOTP(inputOTPValue,"mobile",this.data.mobile).subscribe(res => {
        console.log(res);
        this.verifyOTPUpdating = false;

        if (res.result == 'Success' || res.result == 'success') {
          this.verifyOTPError = false;
          this.user.isMobVerified = true;
          this.verifyOTPUpdated = false;
          this.user.mobile = this.data.mobile
          localStorage.setItem('mobile', JSON.stringify(this.user.mobile));
          localStorage.setItem('isMobVerified', JSON.stringify(this.user.isMobVerified));
          this.closeDialog(true);
          this.toastrService.success('Mobile verified successfully');
          this.global.trackEvent('very-phone-dialog', 'Verify OTP Success');

          // if (this.router.url.indexOf('opportunity/') > -1 && this.router.url.indexOf('/apply') == -1) {
          //   this.router.navigate([this.router.url.split('?')[0] + '/apply']);
          // }
        } else {
          this.verifyOTPError = true;
          this.verifyOTPErrorMsg = res.result;
          this.global.trackEvent('very-phone-dialog', 'Verify OTP Failure' + this.verifyOTPErrorMsg);
        }
      },
        (err: HttpErrorResponse) => {
          this.verifyOTPError = true;
          this.verifyOTPUpdating = false;

          if (err.error instanceof Error) {
            this.verifyOTPErrorMsg = 'Client-side error occured';
            // console.log('Client-side error occured!');
          } else {
            this.verifyOTPErrorMsg = 'Server-side error occured';
            // console.log('Server-side error occured!');
          }
        });
    }
  }


  resendOtp() {
    this.api.sendOTP(this.data.mobile, this.data.code).subscribe(res => {
      console.log(res)
    })
  }




  disableResend() {
    this.disableResendBtn = true;
    const angularthis = this;
    if (this.global.isBrowser) {
      (<any>window).setTimeout(function () {
        angularthis.disableResendBtn = false;
      }, 10000);
    }
  }

}
